<template>
  <div class="virtual-tree">
    <vxe-list class="my-tree" maxHeight="240" :loading="loading" :data="list" ref="virtualTree">
      <template #default="{ items }">
        <div
          class="my-tree-item"
          v-for="item in items"
          :key="item[props.id]"
          :class="[`level-${item._LEVEL}`, {'has-child': item._HAS_CHILDREN, 'is-expand': item._EXPAND, 'active':`${activeValue}` === `${item[props.id]}`, 'single-item':!multiple}]"
          :style="{paddingLeft: `${item._LEVEL * +indentValue}px`}">
          <i class="tree-icon vxe-icon-caret-right el-icon-caret-right" @click.stop="toggleTreeNode(item)"></i>
          <el-checkbox class="my-tree-checkbox" v-model="item.checked" @change="checkboxChange($event,item)" v-if="multiple" :disabled="disabled || item.readonly || item.disabled"></el-checkbox>
          <el-tooltip class="item" effect="dark" placement="top" v-if="+textSize > 0 && item._TEXT.length>+textSize">
            <div slot="content">{{item._TEXT}}</div>
            <span class="tree-label" :class="[{'tree-label__delete':item['_DELETE']}, {'tree-label__disable':item['disabled']}]" @click.stop="labelClick(item)">{{ item._TEXT.substring(0,+textSize-1) }}...</span>
          </el-tooltip>
          <span class="tree-label" :class="[{'tree-label__delete':item['_DELETE']}, {'tree-label__disable':item['disabled']}]" @click.stop="labelClick(item)" v-else>{{ item._TEXT }}</span>
        </div>
      </template>
    </vxe-list>
  </div>
</template>

<script>
import XEUtils from 'xe-utils'
export default {
  name: 'virtualTree1',
  model: {
    prop: 'checked',
    event: 'change'
  },
  props: {
    data: {
      type: Array,
      default: () => []
    },
    checked: { // 选中值
      type: Array | Number | String,
      default: () => []
    },
    props: {
      type: Object,
      default () {
        // isTree 表示数据源是否是树形结构
        return {label: 'label', id: 'value', parentId: 'ParentId', isTree: true, children: 'children', status: 'Status', statusValue: '-1'}
      }
    },
    indent: { // 缩进
      type: String | Number,
      default: () => 20
    },
    multiple: { // 是否多选
      type: Boolean,
      default: () => true
    },
    disabled: {
      type: Boolean,
      default: () => false
    },
    showDelete: { // 筛选是否显示已删除的数据
      type: Boolean,
      default: () => true
    },
    textSize: { // 文本长度限制，超出部分overflow ，0表示不限制
      type: Number | String,
      default: () => 0
    },
    expandLevel: { // 默认展开层级
      type: Number | String,
      default: () => 2
    }
  },
  data () {
    return {
      list: [],
      tree: [],
      loading: true,
      fullList: [],
      checkList: [],
      activeValue: ''
    }
  },
  created () {
    this.initChecked()
    this.data.length === 0 && (this.loading = false) // 没有数据，不会一直显示loading
    // this.loadTree()
  },
  computed: {
    isDelete () {
      return (item) => {
        const {status, statusValue} = this.props
        return (statusValue || '-1').split(',').includes(`${item[(status || 'Status')]}`) || false
      }
    },
    indentValue () {
      return this.multiple ? this.indent : +this.indent - 10
    },
    getLabel () {
      return (item) => {
        const { label, cancelValue, cancelText, cancelField } = this.props
        return label.split(',').map(fieldLabel => {
          if (fieldLabel.includes('|')) {
            let result = ''
            const arr = fieldLabel.split('|')
            for (let i = 0; i < arr.length; i++) {
              result = item[arr[i]]
              if (result) {
                break
              }
            }
            return result
          }
          return `${item[fieldLabel]}${cancelValue && `${item[cancelField]}` === `${cancelValue}` ? `(${cancelText})` : ''}`
        }).filter(c => { return !!c }).join('-')
      }
    }
  },
  methods: {
    initChecked () {
      this.checkList = this.checked
      if (!this.multiple) {
        const {checked} = this
        this.activeValue = (checked && checked.length > 0 && checked[0]) || ''
      }
    },
    loadTree () {
      this.loading = true
      let { parentId, id, isTree, cancelValue, cancelField } = this.props
      parentId = parentId || 'ParentId'
      let treeData = [...(this.data || [])]
      treeData = treeData.sort((a, b) => {
        return +a[parentId] - +b[parentId]
      })

      const _this = this
      if (!this.showDelete) {
        treeData = treeData.filter(item => !_this.isDelete(item))
        if (cancelValue) {
          treeData = treeData.filter(item => `${item[cancelField]}` !== `${cancelValue}`)
        }
      }
      if (!isTree) { // (!isTree && isTree !== undefined) || isTree === undefined
        treeData = XEUtils.toArrayTree(treeData, {'parentKey': parentId || 'ParentId', 'key': id, 'strict': false})
      }
      // 将树结构拍平，构建列表树结构
      XEUtils.eachTree(treeData, (item, index, items, paths, parent, nodes) => {
        // 层级
        item._LEVEL = nodes.length - 1
        // 是否展开
        item._EXPAND = false
        // 是否可视
        item._VISIBLE = !item._LEVEL
        // 是否有子节点
        item._HAS_CHILDREN = item.children && item.children.length > 0
        // 是否叶子节点
        item._IS_LEAF = !item._HAS_CHILDREN
        item._DELETE = this.isDelete(item) // 删除项
        // console.log('item', item)
        item._TEXT = this.getLabel(item)
        /* const checked = this.checkList || []
        // this.$set(item, 'checked', this.isReset ? false : (item.checked || [...checked].includes(`${item[id]}`) || [...checked].includes(+item[id])))
        item.checked = this.isReset ? false : (item.checked || [...checked].includes(`${item[id]}`) || [...checked].includes(+item[id])) */
      })
      this.tree = treeData
      // console.log('🚀 ~ file: virtualTree.vue:115 ~ loadTree ~ treeData:', treeData)
      // this.refreshTree()
      this.allTreeExpand(true)
      this.loading = false
    },
    toggleTreeNode (row) {
      if (row._HAS_CHILDREN) {
        this.setTreeExpand(row, !row._EXPAND)
      }
    },
    setTreeExpand (row, isExpand) {
      const matchObj = XEUtils.findTree(this.tree, item => item === row)
      row._EXPAND = isExpand
      if (matchObj) {
        XEUtils.eachTree(matchObj.item.children, (item, index, items, path, parent) => {
          item._VISIBLE = parent ? parent._EXPAND && parent._VISIBLE : isExpand
        })
      }
      this.refreshTree()
    },
    allTreeExpand (isExpand) {
      if (isExpand) {
        const level = +this.expandLevel || 1
        XEUtils.eachTree(this.tree, item => {
          item._EXPAND = item._LEVEL < level - 1 && item._HAS_CHILDREN
          item._VISIBLE = item._LEVEL < level // true
        })
      } else {
        XEUtils.eachTree(this.tree, item => {
          item._EXPAND = false
          item._VISIBLE = !item._LEVEL
        })
      }
      this.refreshTree()
    },
    refreshTree () {
      const treeList = XEUtils.toTreeArray(this.tree)
      this.fullList = treeList
      this.list = treeList.filter(item => item._VISIBLE)
    },
    checkboxChange (val, row) {
      row.multiple = false
      this.getChecked(row)
    },
    labelClick (row) {
      if (this.disabled || row.readonly || row.disabled) {
        return
      }
      if (this.multiple) {
        // this.loading = true
        row.checked = !row.checked
        const temp = XEUtils.toTreeArray([row])
        setTimeout(() => {
          temp.filter(item => !item.disabled).map(item => {
          /* // 子级diabled, 父级选中，不联动选择子级
            if (item.disabled) {
              return
            } */
            item.checked = row.checked
          })
          row.multiple = true
          this.getChecked(row)
          this.loading = false
        }, 10)
      } else {
        const {id} = this.props
        this.activeValue = row[id]
        this.$emit('change', row[id], row)
      }
    },
    getChecked (row) {
      const { id } = this.props
      const list = XEUtils.toTreeArray(this.list, {clear: false}).filter(item => item.checked)
      const values = []
      const items = list.reduce((result, item) => {
        if (!values.includes(item[id])) {
          result.push(item)
          values.push((item[id]))
        }
        return result
      }, [])
      this.$emit('change', values, items, row)
    },
    reset () {
      this.checkList = this.multiple ? [] : ''
      this.activeValue = ''
      this.loadTree()
      this.$emit('change', this.checkList)
    },
    scrollTo (left = 0, top = 0) {
      this.$refs['virtualTree'].scrollTo(left, top)
    }
  },
  watch: {
    'data': function (newVal) {
      newVal && this.loadTree()
    },
    'checked': function (newVal) {
      this.initChecked()
    }
  }

}
</script>

<style lang="less">
.my-tree {
  padding: 0 0 0 10px;
  border: 1px solid #e8eaec;
  .tree-label{
    cursor: pointer;
    flex: 2;
    &__delete{
      color: red;
      text-decoration: line-through;
    }
    &__disable {
      cursor: not-allowed;
      color: #ccc;
    }
  }
  &-checkbox:last-of-type{
    margin-right: 5px;
  }
}
.my-tree .my-tree-item {
  height: 32px - 5px;
  line-height: 32px - 5px;
  white-space: nowrap;
  display: flex;
  &.active,&.single-item:hover{
    background-color: #F5F7FA;
    color: #409EFF;
  }
  &.single-item{
    cursor: pointer;
  }
}
.my-tree .my-tree-item.has-child .tree-icon {
  visibility: visible;
  transition: all 0.3s;
}
.my-tree .my-tree-item.is-expand .tree-icon {
  transform: rotate(90deg);
}
.my-tree .tree-icon {
  cursor: pointer;
  width: 20px;
  line-height: 20px+7px;
  text-align: center;
  visibility: hidden;
  user-select: none;
}
</style>



// WEBPACK FOOTER //
// src/components/virtualTree/src/virtualTree.vue